import { render } from "./HomeQuestion.vue?vue&type=template&id=bdc3f34c&scoped=true"
import script from "./HomeQuestion.vue?vue&type=script&lang=js"
export * from "./HomeQuestion.vue?vue&type=script&lang=js"

import "./HomeQuestion.vue?vue&type=style&index=0&id=bdc3f34c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc3f34c"]])

export default __exports__